import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { incidentService } from "@iso/services";

/**
 * Determines whether the current user is a Safety Admin for the active property.
 * Uses the backend incident settings endpoint (same source as IncidentList).
 *
 * @returns {boolean} isSafetyAdmin
 */
const useIsSafetyAdmin = () => {
  const [isSafetyAdmin, setIsSafetyAdmin] = useState(false);
  const activePropertyId = useSelector((state) => state.property.activePropertyId);
  const activePermission = useSelector((state) => state.permission?.activePermission);

  useEffect(() => {
    if (activePropertyId) {
      incidentService
        .getSettings(activePropertyId)
        .then((response) => {
          const isAdmin =
            response?.is_safety_admin ||
            ["owner", "admin"].includes(activePermission);
          setIsSafetyAdmin(isAdmin);
        })
        .catch((err) => {
          console.error("Failed to load incident settings", err);
        });
    }
  }, [activePropertyId, activePermission]);

  return isSafetyAdmin;
};

export default useIsSafetyAdmin;
